<template>
  <div
    v-if="filteredSorting && filteredSorting.length"
    id="appliedSortingSection"
    class="d-flex align-items-center text-nowrap"
  >
    <label class="mb-0 mr-2 applied-sorting-label">Applied sorting: </label>
    <div class="d-flex justify-content-space-between button-wrapper">
      <div class="d-flex badge-wrapper bg-light pb-0 applied-sorting-content">
        <div
          class="d-flex mb-1 pr-2 border-right sorting-head"
          style="flex: 1"
        >
          <b-badge
            v-for="sort in filteredSorting"
            variant="info"
            size="sm"
            class="mr-2 d-flex align-items-center sorting-item-badge"
            :class="{truncated: isCriterionNameTruncated(sort.FieldNameOrGuid)}"
          >
            <span class="badge-text">
              {{ sort.FieldNameOrGuid === "__validationStatus__"
                ? "recordStatus"
                : getFieldStringNameIfGuid(sort.FieldNameOrGuid) }}
              <!--text-->
              :
              <!--text-->
              {{ sort.ascending ? "asc" : "desc" }}
            </span>
            <span
              class="ml-1 delete-filter-item"
              @click="removeSorting(sort.FieldNameOrGuid)"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </span>
          </b-badge>
        </div>
        <div class="pl-2 clear-button d-flex align-items-center">
          <b-button
            id="clearSorting"
            size="sm"
            variant="secondary"
            @click="clearAllSorting"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
            Clear Sorting
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getFieldStringNameIfGuid} from '../../../utils';
import {createNamespacedHelpers} from 'vuex';

const {mapState} = createNamespacedHelpers('app');
const {mapGetters} = createNamespacedHelpers('dataManagement');

export default {
  name: 'SortingHeader',
  props: {
    sorting: {
      type: Array,
      required: true,
    },
    grouping: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['fields']),
    filteredSorting() {
      return this.sorting.filter(sort => !this.grouping.includes(this.getFieldStringNameIfGuid(sort.FieldNameOrGuid), false));
    },
  },
  methods: {
    getFieldStringNameIfGuid,
    async clearAllSorting() {
      this.$emit('sortChange', []);
    },
    async removeSorting(filterNameOrGuid) {
      const updatedSortingArray = this.sorting.filter(s => (
        s.FieldNameOrGuid !== filterNameOrGuid
      ));

      this.$emit('sortChange', updatedSortingArray, true);
    },
    isCriterionNameTruncated(name) {
      return name ? name.length > 10 : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-head {
  max-width: 500px;
  overflow: auto;
}

.clear-button {
  padding-bottom: 0.3rem;
}

::-webkit-scrollbar {
  height: 7px;
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.applied-sorting-label {
  width: 100px;
}
.applied-sorting-content {
  min-width: 240px;
}
.sorting-head {
  flex-wrap: wrap;
  gap: 1px;

  .sorting-item-badge {
    height: 25px;
  }
}
</style>
